
import {defineComponent} from 'vue';
import {DEVICE_LG, DEVICE_XL} from '../../../../composables/useResponsive';
import {cellMixin} from './cell-mixin';

export default defineComponent({
  name: 'oxd-table-cell-default',

  mixins: [cellMixin],

  props: {
    item: {
      required: true,
    },
  },

  computed: {
    showHeader(): boolean {
      return !(
        this.screenState.screenType === DEVICE_LG ||
        this.screenState.screenType === DEVICE_XL
      );
    },
  },
});
